import { baseEnvironment } from "./environment.base";
import { ENVIRONMENT } from '@evc/platform';

export const environment = {
    ...baseEnvironment,
    name: 'Development',
    baseUrl: 'https://vantadataviewer.olympus-ims-dev.com/',
    EVC_REDIRECT_URL: 'https://vdv.connect.dev-evcnt.com/',
    ENV: ENVIRONMENT.development,
    production: false,
    AUTH_CLIENT_ID: 'ff9d6cf2-db54-4a69-8d72-76953cfa5024',
    PROTECTED_URIS: {
      VANTAAPP: "https://vdv.connect.dev-evcnt.com/api/",
    },
    DEVICE_API_URL: "https://device.api.ca.connect.dev-evcnt.com"
  };
